import {
  GKButton,
  GKDatePicker,
  GKModal,
  GKTextField,
  Grid2,
} from "components";
import dayjs from "dayjs";
import { useMutation } from "hooks/useQueries";
import { Controller } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { v4 as uuid } from "uuid";

interface Props {
  form: any;
  selectedId: any;
  rebalanceUpdateType: any;
  id: any;
}

const UpdateRebalanceDate = ({
  open,
  setOpen,
  form,
  selectedId,
  id,
  rebalanceUpdateType,
}: Props & GKModalProps) => {
  // =+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+
  const { mutate: handleUpdateModelPortfolio, isLoading } = useMutation({
    mutationFn: (item: any) =>
      axiosInstance.post(`/model_portfolio/${id}/get_version_on_date/`, {
        id: item?.id,
        date: item?.date,
      }),
    onSuccess: (response: any) => {
      const da = form
        .getValues("stocks")
        ?.filter(
          (d: any) =>
            !response?.data?.allocItem
              ?.map((inD: any) => inD?.isinCode)
              ?.includes(d?.isinCode),
        );

      form.setValue("stocks", [
        ...response?.data?.allocItem?.map((item: any) => {
          return {
            ...item,
            uuid: uuid(),
          };
        }),
        ...da,
      ]);
      setOpen(false);
    },
  });

  // =+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+
  const handleUpdateVersion = (values: any) => {
    handleUpdateModelPortfolio({
      id: selectedId,
      date: dayjs(values.date).format("YYYY-MM-DD"),
    });
  };

  form.watch();

  return (
    <GKModal
      open={open}
      modalTitle="Rebalance Date"
      setOpen={setOpen}
      footer={
        <GKButton
          loading={isLoading}
          onClick={() => {
            if (rebalanceUpdateType === "versionName") {
              setOpen(false);
            } else if (form.getValues("date") === "Invalid Date") {
              setOpen(false);
            } else {
              handleUpdateVersion(form.getValues());
            }
          }}
          variant="contained"
        >
          Submit
        </GKButton>
      }
    >
      <Grid2 container>
        {rebalanceUpdateType === "versionName" && (
          <Grid2 size={12}>
            <Controller
              control={form.control}
              name="versionName"
              render={({ field }) => (
                <GKTextField {...field} inputLabel="Version Name" />
              )}
            />
          </Grid2>
        )}
        {rebalanceUpdateType !== "versionName" && (
          <Grid2 size={12}>
            <Controller
              control={form.control}
              name="date"
              render={({ field }) => (
                <GKDatePicker
                  {...field}
                  onChange={(e) => {
                    field.onChange(dayjs(e).format("YYYY-MM-DD"));
                  }}
                  value={dayjs(field.value)}
                  inputLabel="Model Portfolio start date"
                  disableFuture={false}
                />
              )}
            />
          </Grid2>
        )}
      </Grid2>
    </GKModal>
  );
};

export default UpdateRebalanceDate;
